import styled from 'styled-components'

export const RowWrapper = styled.div`
  display: flex;
`
